"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataFeedServer__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
const ethers_1 = require("ethers");
const _abi = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "beaconSetId",
                type: "bytes32",
            },
            {
                indexed: false,
                internalType: "int224",
                name: "value",
                type: "int224",
            },
            {
                indexed: false,
                internalType: "uint32",
                name: "timestamp",
                type: "uint32",
            },
        ],
        name: "UpdatedBeaconSetWithBeacons",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "beaconId",
                type: "bytes32",
            },
            {
                indexed: false,
                internalType: "int224",
                name: "value",
                type: "int224",
            },
            {
                indexed: false,
                internalType: "uint32",
                name: "timestamp",
                type: "uint32",
            },
        ],
        name: "UpdatedBeaconWithSignedData",
        type: "event",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "containsBytecode",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "getBalance",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getBlockBasefee",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getBlockNumber",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getBlockTimestamp",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getChainId",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes[]",
                name: "data",
                type: "bytes[]",
            },
        ],
        name: "multicall",
        outputs: [
            {
                internalType: "bytes[]",
                name: "returndata",
                type: "bytes[]",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes[]",
                name: "data",
                type: "bytes[]",
            },
        ],
        name: "tryMulticall",
        outputs: [
            {
                internalType: "bool[]",
                name: "successes",
                type: "bool[]",
            },
            {
                internalType: "bytes[]",
                name: "returndata",
                type: "bytes[]",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32[]",
                name: "beaconIds",
                type: "bytes32[]",
            },
        ],
        name: "updateBeaconSetWithBeacons",
        outputs: [
            {
                internalType: "bytes32",
                name: "beaconSetId",
                type: "bytes32",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
class DataFeedServer__factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    connect(runner) {
        return super.connect(runner);
    }
    static bytecode = _bytecode;
    static abi = _abi;
    static createInterface() {
        return new ethers_1.Interface(_abi);
    }
    static connect(address, runner) {
        return new ethers_1.Contract(address, _abi, runner);
    }
}
exports.DataFeedServer__factory = DataFeedServer__factory;
//# sourceMappingURL=DataFeedServer__factory.js.map